// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".repeater-form[data-v-10fa17c0] {\n  overflow: hidden;\n  transition: 0.35s height;\n}", ""]);
// Exports
module.exports = exports;
